"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "surface": "#fff",
    "surface-container": "#e6e6e6",
    "surface-container-low": "#f2f2f2",
    "surface-container-high": "#1a1a1a",
    "on-surface": "#1a1a1a",
    "on-surface-variant": "#666",
    "on-surface-inverse": "#fff",
    "outline": "#e6e6e6",
    "outline-low": "#f2f2f2",
    "outline-high": "#cccbcd"
};
// Path: src/tokens/colors/neutrals.ts
//# sourceMappingURL=neutrals.js.map